import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, inject, ViewChild } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { map } from 'rxjs';
import { BreadcrumbComponent } from '../../components/common/breadcrumb/breadcrumb.component';
import { RefreshWidgetComponent } from '../../components/common/refresh-widget/refresh-widget.component';

@Component({
  selector: 'app-page-layout',
  templateUrl: './page-layout.component.html',
  styleUrls: ['./page-layout.component.scss'],
  imports: [
    RouterModule,
    MatSidenavModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    BreadcrumbComponent,
    RefreshWidgetComponent
  ]
})
export class PageLayoutComponent {
  private readonly breakpointObserver = inject(BreakpointObserver);

  @ViewChild('drawer') drawer?: MatDrawer;

  readonly isMobile = toSignal(
    this.breakpointObserver.observe(['(max-width: 599px)']).pipe(
      map((result) => result.matches)
    ),
    { initialValue: false }
  );

  closeMobileMenu(trigger: MatMenuTrigger): void {
    trigger.closeMenu();
  }

  toggleDrawer(): void {
    void this.drawer?.toggle();
  }
}
